module.exports = require('../../dist/utils/loans');
